import { Component, OnInit } from "@angular/core";
import { AuthService } from "../../../../services/auth.service";
import { CommonService } from "../../../../services/common.service";
import { UserService } from "../../../../services/user.service";
import { PlanService } from "../../../../services/plan.service";

@Component({
  selector: "page-mypage-index",
  templateUrl: "./index.component.html",
})
export class PageMyPageIndexComponent implements OnInit {
  public moment: any;

  public userData: any = {};
  public viewedPlans: any = {};
  public favouritePlans: any = {};

  public activatedStation: any = {};

  /* FOR TEMPORARY ASSIGNING */
  public tempData: any = {};

  constructor(
    public authService: AuthService,
    public commonService: CommonService,
    public userService: UserService,
    public planService: PlanService
  ) {
    this.moment = this.commonService.getMoment();

    /* VIEWED & FAVOURITE PLANS */
    this.viewedPlans = {
      keyMap: {},
      list: [],
    };

    this.favouritePlans = {
      keyMap: {},
      list: [],
    };

    this.tempData.currentHistoryTab = 1;
  }

  async ngOnInit() {
    /* CHECK IF NOT LOGGED IN */
    if (!this.authService.isLoggedIn()) {
      return this.commonService.redirectToRoute(
        this.commonService.routePaths.pageHomeNoParam
      );
    }

    /* SET PAGE TITLE */
    this.commonService.setTitle(
      `バスブックマークへようこそ！マイページ | バスブックマーク`
    );

    /* SHOW PAGE LOADER */
    this.commonService.showPageLoader("読み込み中...");

    /* GET USER DATA */
    this.userData = await this.userService.getProfileInfo();
    this.userData.age = this.moment().diff(this.userData.birth_date, "years");
    /* END */

    /* GET VIEWED & FAVOURITE PLANS */
    let data = this.planService.getViewedPlans();
    if (data) {
      this.viewedPlans = data;
    }

    data = this.planService.getFavouritePlans();
    if (data) {
      this.favouritePlans = data;
    }
    /* END */

    /* HIDE PAGE LOADER */
    this.commonService.hidePageLoader();
  }

  userLogout() {
    /* DO LOGOUT */
    this.authService.logout();

    /* REDIRECT THEN */
    window.location.href = window.location.origin;
  }
}
